import moment from "moment-timezone";

import { FILTER_VALUE_DATE_FORMAT } from "../FilterBarDateTimeRange/FilterBarDateTimeRangeUtils";

import { PeriodTimeRangeFilterValue } from "./FilterBarPeriodTimeRangeTypes";

type MomentRange = [moment.Moment | null, moment.Moment | null] | null;

export function toPeriodFilterValue(
    range: MomentRange
): PeriodTimeRangeFilterValue {
    if (!range) {
        return null;
    }
    return [
        range[0]
            ? range[0].startOf("month").format(FILTER_VALUE_DATE_FORMAT)
            : null,
        range[1]
            ? range[1].endOf("month").format(FILTER_VALUE_DATE_FORMAT)
            : null,
    ];
}
